import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import './Menu.css';

class Menu extends Component {
    render() {
        return (
            <div className="header-menu">
                <NavLink className="header-menu__item" to="/accueil/1">Accueil</NavLink>
                <NavLink className="header-menu__item" to="/recettes">Recettes</NavLink>
                <NavLink className="header-menu__item" to="/partenaires">Partenaires</NavLink>
                <NavLink className="header-menu__item" to="/contact">Contact</NavLink>
            </div>
        );
    }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.js